class InfoAppSumo implements ng.IComponentController {
    name: string;
    displayName: string;
    isFree: boolean;
    price: number;
    expirationDate: number;
    expirationMediumDate: string;
    onRenew: Function = this.onRenew || angular.noop;

    constructor(private $filter: ng.IFilterService) {
        this.expirationMediumDate = this.$filter('date')(this.expirationDate * 1000, 'mediumDate');
    }

    renew() {
        this.onRenew();
    }
}

angular.module('animatronApp.settings').component('infoAppSumo', {
    bindings: {
        name: '<',
        displayName: '<',
        isFree: '<',
        price: '<',
        expirationDate: '<',
        onRenew: '&'
    },
    controller: InfoAppSumo,
    templateUrl: require('settings/info-app-sumo.html')
});




// WEBPACK FOOTER //
// ./app/assets/javascripts/settings/directives/infoAppSumo.ts